import { ReportFeatures } from '@hcs/types';

export const dataHcEventSectionRefreshReport = 'Refresh Report';
export const REFRESH_REPORT_FEATURES: ReportFeatures[] = [
  ReportFeatures.ReportDataRefresh,
];
